/** Keep personal navigation in the same deployment, including isolated previews. */
export function playerAppOrigin(host = window.location.hostname): string {
  const preview = /^pr-(\d+)-business\.badmintonwarriors\.com$/.exec(host);
  return preview
    ? `https://pr-${preview[1]}-player.badmintonwarriors.com`
    : host === "staging-business.badmintonwarriors.com"
      ? "https://staging.badmintonwarriors.com"
      : host === "business.badmintonwarriors.com"
        ? "https://badmintonwarriors.com"
        : "http://127.0.0.1:3000";
}
